import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Content, ContentTxt} from '../content/content.txt';
import {BehaviorSubject, Subject} from 'rxjs';


@Injectable({
    providedIn: 'root',
})
export class BaseWebservice {


    public  setData(key, value ){
        localStorage.setItem(key, JSON.stringify(value))
    }

    public getData(key){
        return  JSON.parse(localStorage.getItem(key))
    }




    private navigationSource = new Subject<string>();
    navigation$ = this.navigationSource.asObservable();
    private whichStatusActiveList = [
        "aboutyou",
        "executor",
        "estate",
        "gifts",
        "funeralwishes",
    ]


    private _plan = null;
    private _plan_paid = false;


    get plan(): any {

        return this._plan;
    }

    set plan(value: any) {
        this._plan = value;
    }

    get plan_paid(): any {

        return this._plan_paid;
    }

    set plan_paid(value: any) {
        this._plan_paid = value;
    }
    private _step = null;


    get step(): any {

        return this._step;
    }

    set step(value: any) {
        this._step = value;
    }

    whichStatusActive(key) {
        if (key == "") return
        if (key == "funeralwishes") {
            this.appGlobalProgressStatusActive("funeralwishes")
        } else {
            let activeIndex = this.whichStatusActiveList.findIndex(value => value == key) + 1
            this.appGlobalProgressStatusActive(this.whichStatusActiveList[activeIndex])


        }


    }

    public isPlanBronze() {
        let isPlanBronze = this.plan != null && this.plan == 0
        let isWillComplete = this.step != null && this.step == 'funeralwishes'
        // add condition if the will is completed or not
        return isPlanBronze && isWillComplete;
    }

    private processCompletionStatus: 'aboutyou' | 'executor' | 'estate' | 'gifts' | 'funeralwishes' | ''


    /*
    * Set on Logout
    * */
    private defaultProcessListing = [
        {label: "About You", isFinished: false, defaultColor: "#EF8C43", completedColor: "#EF8C43", icon: "fas fa-info-circle", id: 'aboutyou', level: undefined, isActive: true},
        {label: "Executors", isFinished: false, defaultColor: "#E5E5E5", completedColor: "#EF8C43", icon: "fab fa-gratipay", id: "executor", level: undefined, isActive: undefined},
        {label: "Estate", isFinished: false, defaultColor: "#E5E5E5", completedColor: "#EF8C43", icon: "fab fa-gratipay", id: "estate", level: undefined, isActive: undefined},
        {label: "Gifts", isFinished: false, defaultColor: "#E5E5E5", completedColor: "#EF8C43", icon: "fab fa-gratipay", id: "gifts", level: undefined, isActive: undefined},
        {label: "Funeral Wishes", isFinished: false, defaultColor: "#E5E5E5", completedColor: "#EF8C43", icon: "fab fa-gratipay", id: 'funeralwishes', level: undefined, isActive: undefined},

    ]


    /*
    * Used In app for state managment
    * */
    private processListing = [
        {label: "About You", isFinished: false, defaultColor: "#EF8C43", completedColor: "#EF8C43", icon: "fas fa-info-circle", id: 'aboutyou', level: undefined, isActive: true},
        {label: "Executors", isFinished: false, defaultColor: "#E5E5E5", completedColor: "#EF8C43", icon: "fab fa-gratipay", id: "executor", level: undefined, isActive: undefined},
        {label: "Estate", isFinished: false, defaultColor: "#E5E5E5", completedColor: "#EF8C43", icon: "fab fa-gratipay", id: "estate", level: undefined, isActive: undefined},
        {label: "Gifts", isFinished: false, defaultColor: "#E5E5E5", completedColor: "#EF8C43", icon: "fab fa-gratipay", id: "gifts", level: undefined, isActive: undefined},
        {label: "Funeral Wishes", isFinished: false, defaultColor: "#E5E5E5", completedColor: "#EF8C43", icon: "fab fa-gratipay", id: 'funeralwishes', level: undefined, isActive: undefined},

    ]

    /*
    *
    * On completion of process
    * */
    private processListingComplete = [
        {label: "About You", isFinished: true, defaultColor: "#EF8C43", completedColor: "#EF8C43", icon: "fas fa-info-circle", id: 'aboutyou', level: undefined, isActive: true, chevDown: "fa-chevron-circle-down", chevUp: "fa-chevron-circle-up"},
        {label: "Executors", isFinished: true, defaultColor: "#E5E5E5", completedColor: "#EF8C43", icon: "fab fa-gratipay", id: "executor", level: undefined, isActive: undefined, chevDown: "fa-chevron-circle-down", chevUp: "fa-chevron-circle-up"},
        {label: "Estate", isFinished: true, defaultColor: "#E5E5E5", completedColor: "#EF8C43", icon: "fab fa-gratipay", id: "estate", level: undefined, isActive: undefined, chevDown: "fa-chevron-circle-down", chevUp: "fa-chevron-circle-up"},
        {label: "Gifts", isFinished: true, defaultColor: "#E5E5E5", completedColor: "#EF8C43", icon: "fab fa-gratipay", id: "gifts", level: undefined, isActive: undefined, chevDown: "fa-chevron-circle-down", chevUp: "fa-chevron-circle-up"},
        {label: "Funeral Wishes", isFinished: true, defaultColor: "#E5E5E5", completedColor: "#EF8C43", icon: "fab fa-gratipay", id: 'funeralwishes', level: undefined, isActive: undefined, chevDown: "fa-chevron-circle-down", chevUp: "fa-chevron-circle-up"},

    ]


    setDataAsdefault() {
        this.processListing = []
        this.processListing.push(...this.defaultProcessListing)

        console.table(this.processListing)

    }


    private contentSubject = new BehaviorSubject("");
    getContentObservable = this.contentSubject.asObservable();


    setContentData(data ?) {
        this.contentSubject.next(data);
    }


    /*
     * set the current level of completion of the indivivdual  stage
     * */
    updateProcessListingLevel(id: 'aboutyou' | 'executor' | 'estate' | 'gifts' | 'funeralwishes', level: number) {

        let processCompletionIndex = this.processListing.map((value, index) => value.id).findIndex(value => value == id);
        this.processListing[processCompletionIndex].level = level;
        return this.processListing[processCompletionIndex]

    }

    /*
    * Fetch the current level of completion of the indivivdual stage
    * */
    fetchProcessListingLevel(id: 'aboutyou' | 'executor' | 'estate' | 'gifts' | 'funeralwishes') {
        let processCompletionIndex = this.processListing.map((value, index) => value.id).findIndex(value => value == id);
        ;
        return this.processListing[processCompletionIndex].level

    }


    /*
    *
    * set the stage completion status
    * */
    public appGlobalProgressStatus(whichStatus: 'aboutyou' | 'executor' | 'estate' | 'gifts' | 'funeralwishes' | '' = "") {

        // if(whichStatus=="")return this.defaultProcessListing;
        this.processCompletionStatus = whichStatus
        let processCompletionIndex = this.processListing.map((value, index) => value.id).findIndex(value => value == this.processCompletionStatus)
        this.processListing.map((value, index) => {
            if (index <= processCompletionIndex) {
                value.isFinished = true
            }
        })
        this.whichStatusActive(whichStatus)
        return this.processListing
    }


    /*
*
* set the stage completion status
* */
    public appGlobalProgressStatusActive(whichStatus) {

        this.processCompletionStatus = whichStatus
        this.processListing.map((value, index) => value.isActive == false)
        let processCompletionIndex = this.processListing.map((value, index) => value.id).findIndex(value => value == this.processCompletionStatus)
        this.processListing[processCompletionIndex].isActive = true

        return this.processListing
    }


    /*
     * get the stage completion status
     * */
    getProcessStatus(page) {
        let processCompletionIndex = this.processListing.map((value, index) => value.id).findIndex(value => value == page)


        return this.processListing[processCompletionIndex].isFinished
    }

    /*
    * get the stage completion status
    * */
    getCompletionStatus() {
        return this.appGlobalProgressStatus()
    }

    getCompleteProcess() {
        return this.processListingComplete
    }


    /*
    * get the web context like text and image , background image for the side bar
    * */
    getContentForPage(which?): Content {
        let content




        if (which) {
            content = ContentTxt.whichContent(which)
        } else {

            let endpoint = window.location.href.split('/')[window.location.href.split('/').length - 1];


            if (window.location.href.includes("reset-password")) {

                content = ContentTxt.whichContent("reset_passowrd")
            } else {
                if (endpoint == "dashboard") {

                    let dashBaord = this.processListing.find(value => {
                        if (value.isFinished == false) {
                            return value
                        }
                    })

                    if (dashBaord)
                        content = this.getContentForDashbaord(dashBaord.id);
                    else
                        content = this.getContentForDashbaord("fnishDash");

                }
                else if(endpoint =='reg'){
                    content = ContentTxt.whichContent('registration')
                }

                else {
                    content = ContentTxt.whichContent(endpoint)
                }
            }

        }


        return content ? content : ""

    }


    getContentForDashbaord(key) {

        if (key == "aboutyou") return ContentTxt.whichContent("aboutyouDash");
        if (key == "executor") return ContentTxt.whichContent("executorDash");
        if (key == "estate") return ContentTxt.whichContent("estateDash");
        if (key == "gifts") return ContentTxt.whichContent("giftsDash");
        if (key == "funeralwishes") return ContentTxt.whichContent("funeralwishesDash");
        if (key == "fnishDash") return ContentTxt.whichContent("fnishDash");
    }

    movePrevious() {
        this.navigationSource.next("prev")
    }

    moveNext() {
        this.navigationSource.next("next")

    }


}
